import { Pagination } from "@itandi/itandi-bb-ui";
import clsx from "clsx";
import type { ReactNode } from "react";
import React from "react";
import { Container } from "~/components/common/container/Container";
import { AdminLayout } from "~/components/common/layouts/AdminLayout";
import { SearchInput } from "~/components/common/parts/search/SearchInput";
import { CompanyRow } from "~/components/specifics/admin/CompanyRow";
import { useCompanySettings } from "~/hooks/useCompanySettings";
import type { CompanySettingWithStore } from "~/models/CompanySetting";
import Styles from "./Page.module.scss";

export const Page: React.FC = () => {
	const [pageNum, setPageNum] = React.useState<number>(1);
	const [searchText, setSearchText] = React.useState<string>("");
	const { data, mutate } = useCompanySettings().index(searchText, pageNum);
	const handleMutate = React.useCallback(async (): Promise<void> => {
		await mutate();
	}, [mutate]);
	const searchInputRef = React.useRef(null);
	const handleChangeSearchText = React.useCallback(
		(searchWord: string) => {
			setSearchText(searchWord);
			setPageNum(1);
		},
		[setSearchText]
	);
	const handleChangePage = React.useCallback(
		(newPageNumber: number) => {
			setPageNum(newPageNumber);
		},
		[setPageNum]
	);
	const renderCompanyRow = React.useCallback(
		(companySetting: CompanySettingWithStore): ReactNode => (
			<CompanyRow
				companySetting={companySetting}
				handleMutate={handleMutate}
				key={companySetting.companyMasterId}
			/>
		),
		[handleMutate]
	);

	return (
		<AdminLayout>
			<Container title="管理会社一覧">
				<div className={Styles.TableTopArea}>
					<div className={Styles.SearchArea}>
						<SearchInput
							handleChange={handleChangeSearchText}
							placeholder="管理会社名で検索"
							ref={searchInputRef}
						/>
					</div>
				</div>
				<div className={clsx(Styles.TableContainer)}>
					<table className={Styles.CompanyTable}>
						<thead>
							<tr className={Styles.CompanyRow}>
								<th className={Styles.IdCell}>
									<div>company_master_id</div>
									<div>auth_id</div>
								</th>
								<th className={Styles.NameCell}>管理会社名</th>
								<th className={Styles.ProxyLoginCell}>操作</th>
							</tr>
						</thead>
						<tbody>{data !== null && data.objects.map(renderCompanyRow)}</tbody>
					</table>
				</div>
				{data !== null && (
					<div className={Styles.PaginationArea}>
						<Pagination
							currentPageNum={pageNum}
							maxPageNum={data.sumPageCount}
							onPageChange={handleChangePage}
						/>
					</div>
				)}
			</Container>
		</AdminLayout>
	);
};
